import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type {
  ReferenceRangeCriticality,
  ReferenceRanges,
} from "@/types/observations";

export interface BMIRecord {
  bmi: number;
  effectiveDate: string;
  criticality?: ReferenceRangeCriticality | null;
  referenceRanges?: ReferenceRanges | null;
}

export interface GetBMIHistoryResponse {
  bmiHistory: BMIRecord[];
}

export const useBmiHistory = ({
  patientId,
  enabled = true,
}: {
  patientId: string;
  enabled?: boolean;
}) => {
  return useApi<GetBMIHistoryResponse>({
    queryOptions: {
      enabled: Boolean(patientId && enabled),
      queryKey: QueryKeys.Patient.MedicalRecords.Vitals.BMI_HISTORY(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get<GetBMIHistoryResponse>(
          "/charting/vitals/bmi/history",
          {
            params: { patient_id: patientId },
          },
        );
        return response.data;
      },
    },
  });
};
